<!-- Derived from Lucide (https://lucide.dev), ISC License; portions from Feather, MIT. See LICENSE in this folder. -->
<!-- Head and shoulders as separate solids. -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2zM15.5 7a3.5 3.5 0 1 0 -7 0a3.5 3.5 0 1 0 7 0Z"
    />
  </svg>
</template>
